import * as React from 'react';
import { Grid } from '@material-ui/core';
import { Checkbox, WhiteLabelMobileAvatar } from '@mitchell/react.component.ux';
import { TranslationService } from "../../../common";
import { QuestionnaireEvaluationQuestionType } from "../../../questionnaireEvaluation";
import { APPLICATION_CONTENT, BrandedNotificationWorkflowSubTypes, BrandedNotificationWorkflowTypes, NONE } from "../../../brandedNotification";
import { PhotoCaptureAttributeType, PhotoCapture, PhotoCaptureAssignmentTypes } from '../../enums';
import { PhotoCaptureConstants, PhotoCaptureScriptQuestionIds, IntelligentPhotoCatureImageConstant, ScriptQuestionConstant, DISABLE_DEVICE_LIBRARY_WARNING } from '../../constants';
import { isDeviceLibraryDisabled, getImageClassByAttributeType, getEstimatorSummaryHeaderText } from '../../utilities';
import { PhotoCaptureFraudWarningModal } from '../PhotoCaptureFraudWarningModal';
import { StyledDivAvatarSpechBoxLayout, StyledPreLoadQuestionContent, StyledDivDefaultImage, StyledDivCircle, StyledContentPaper, StyledCircleSpan, StyledGridScriptText, StyledLabel, StyledLabelBottom, StyledDivContentContainer, LinkButton, LinkContainer } from './IntelligentScriptQuestion.style';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
export const IntelligentScriptQuestionComponent = (props) => {
    const { questionText, questionSubType, appTheme, languages, onLanguageChange, isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, isContextUpdated, contextId, isTermsAndConditionAccepted, warningMessage, pbeAsgTaskId, fraudStatement, fraudWarningAccept, language, assignmentType, isFraudWarningApiStatus, disableLibrary, hasEstimatorWorkflow, vehicle, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction, photoCaptureUpdateTncAction, photoCaptureGetFraudWarningDataAction, photoCaptureUpdateFraudWarningAcceptAction, getConfigurationDataAction } = props;
    const [isTNCAccepted, setIsTNCAccepted] = React.useState(isTermsAndConditionAccepted);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [fraudWarningAccepted, setFraudWarningAccepted] = React.useState(fraudWarningAccept);
    let estimatorSummaryHeaderText = appTheme.headerText;
    const translateFn = TranslationService.translate;
    let shouldLanguageDropdownDisplay = questionSubType === PhotoCaptureAttributeType.DEFAULT;
    const btnLabel = shouldLanguageDropdownDisplay
        ? translateFn(PhotoCaptureConstants.GET_STARTED)
        : translateFn(PhotoCaptureConstants.NEXT);
    const isDeviceLibDisabled = shouldLanguageDropdownDisplay && isDeviceLibraryDisabled(disableLibrary);
    if (hasEstimatorWorkflow)
        estimatorSummaryHeaderText = getEstimatorSummaryHeaderText(vehicle);
    const onChange = (configureLanguage) => {
        onLanguageChange && onLanguageChange(configureLanguage);
        const brandedNotificationInputs = {
            notificationLanguage: configureLanguage || '',
            workflowType: BrandedNotificationWorkflowTypes.PHOTO_CAPTURE,
            workflowSubType: BrandedNotificationWorkflowSubTypes.APPLICATION,
            notificationType: NONE,
            underWritingCompany: '',
            contentType: APPLICATION_CONTENT
        };
        getConfigurationDataAction(brandedNotificationInputs, companyCode, '');
        evaluationDocId &&
            questionnaireId &&
            changeQuestion(evaluationDocId, questionnaireId, 0, QuestionnaireEvaluationQuestionType.FIRST);
    };
    const changeQuestion = (evaluationDocId, questionnaireId, questionnaireQuestionId, questionType) => {
        photoCaptureUpdateTncAction(isTNCAccepted);
        shouldLanguageDropdownDisplay && photoCaptureUpdateFraudWarningAcceptAction(fraudWarningAccepted);
        photoCaptureResetContextAction();
        const questionGetParams = {
            companyCode,
            evaluationDocId: parseInt(evaluationDocId),
            questionnaireId: parseInt(questionnaireId),
            questionnaireQuestionId,
            questionType
        };
        questionnaireEvaluationQuestionGetAction(questionGetParams);
    };
    React.useEffect(() => {
        isSaveSuccess &&
            evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.NEXT);
    }, [isSaveSuccess]);
    React.useEffect(() => {
        if (evaluationDocId && questionnaireQuestionId && isContextUpdated) {
            let answerText = PhotoCaptureConstants.ANSWER_TEXT_DEFAULT;
            if (questionSubType === PhotoCaptureAttributeType.ACKNOWLEDGEMENT) {
                answerText = isTNCAccepted
                    ? PhotoCaptureConstants.ANSWER_TEXT_ACCEPT
                    : PhotoCaptureConstants.ANSWER_TEXT_DECLINE;
            }
            const saveQuestionParams = {
                isCacheOnly: false,
                evalId: evaluationDocId,
                coCode: companyCode,
                shouldIncludeEvalution: false,
                questionsData: [
                    {
                        qustnnrQustnId: questionnaireQuestionId,
                        answer: answerText
                    }
                ]
            };
            questionnaireEvaluationSaveRequestAction(saveQuestionParams);
        }
    }, [isContextUpdated]);
    React.useEffect(() => {
        if (!fraudWarningAccept && isFraudWarningApiStatus && shouldLanguageDropdownDisplay) {
            fraudStatement ? setIsModalOpen(true) : updateContext();
        }
    }, [fraudWarningAccept, isFraudWarningApiStatus]);
    const movePrevious = () => {
        evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.PREVIOUS);
    };
    const updateContextParams = {
        attachmentInfo: [],
        documentId: evaluationDocId,
        fraudWarningAccept: `${fraudWarningAccept}`,
        isTermsAndConditionAccepted: isTNCAccepted ? PhotoCaptureConstants.Y : PhotoCaptureConstants.N,
        status: null,
        vehicle: null
    };
    const updateContext = (contextDataUpdateInput = updateContextParams) => {
        photoCaptureUpdateContextDataAction(contextDataUpdateInput, contextId, companyCode);
    };
    const moveNext = () => {
        if (shouldLanguageDropdownDisplay) {
            if (fraudWarningAccept === 1 || assignmentType === PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE) {
                updateContext();
            }
            else {
                language && photoCaptureGetFraudWarningDataAction(companyCode, pbeAsgTaskId, language);
            }
        }
        else {
            updateContext();
        }
    };
    const onCheckboxClick = () => {
        setIsTNCAccepted(!isTNCAccepted);
    };
    const onIUnderstandClick = () => {
        updateContext(Object.assign(Object.assign({}, updateContextParams), { fraudWarningAccept: '1' }));
        setIsModalOpen(false);
        setFraudWarningAccepted(1);
    };
    const onModalClose = () => {
        setIsModalOpen(false);
    };
    const PreLoadQuestionComponent = props => {
        return (React.createElement(Grid, null,
            React.createElement(StyledPreLoadQuestionContent, null,
                React.createElement(WhiteLabelMobileAvatar, { avatarUrl: appTheme.avatarUrl, avatarColor: appTheme.avatarColor }),
                React.createElement(StyledDivAvatarSpechBoxLayout, null,
                    React.createElement(StyledDivContentContainer, { speechBubbleBackgroundColor: appTheme.speechBoxBackgroundColor },
                        React.createElement("div", { id: "whiteLabelMobileSpeechBox_text", dangerouslySetInnerHTML: { __html: questionText } }),
                        props.children)))));
    };
    const isButtonDisabled = () => {
        if (shouldLanguageDropdownDisplay) {
            return false;
        }
        else
            return !isTNCAccepted;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IntelligentPBEContainerComponent, { warningMessage: isDeviceLibDisabled ? translateFn(DISABLE_DEVICE_LIBRARY_WARNING) : warningMessage, languages: languages || [], onChange: onChange, islanguageHide: !shouldLanguageDropdownDisplay, appTheme: appTheme, defaultLanguage: language, isDeviceLibDisabled: isDeviceLibDisabled, btnLabel: btnLabel, moveNext: moveNext, estimatorSummaryHeaderText: estimatorSummaryHeaderText, movePrevious: hasEstimatorWorkflow ? undefined : !shouldLanguageDropdownDisplay ? movePrevious : undefined, isBtnDisabled: isButtonDisabled(), shouldShowAvatar: shouldLanguageDropdownDisplay },
            shouldLanguageDropdownDisplay && (React.createElement(React.Fragment, null,
                React.createElement(StyledContentPaper, { elevation: 1 },
                    React.createElement(Grid, { wrap: "wrap", container: true, direction: "row", justify: "center", alignItems: "center" },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(StyledLabel, null, translateFn(ScriptQuestionConstant.LABEL_TOP))),
                        React.createElement(Grid, { container: true, item: true, xs: 12, direction: "row", justify: "center", alignItems: "center" },
                            React.createElement(StyledGridScriptText, { container: true, item: true, xs: 6 },
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement(StyledDivCircle, { backgroundColor: appTheme.headerBackgroundColor, id: `${PhotoCapture.PHOTO_CAPTURE}_mobilePhotoCar_text` },
                                        React.createElement(StyledCircleSpan, null, "1"))),
                                React.createElement(Grid, { item: true },
                                    React.createElement("span", null, translateFn(IntelligentPhotoCatureImageConstant.mobilePhotoCar.text)))),
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(StyledDivDefaultImage, { backgroundImage: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_ILLUSTRATION), id: `${PhotoCapture.PHOTO_CAPTURE}_mobilePhotoCar_image` }))),
                        React.createElement(Grid, { container: true, direction: "row", justify: "center", alignItems: "center" },
                            React.createElement(StyledGridScriptText, { container: true, item: true, xs: 6 },
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement(StyledDivCircle, { backgroundColor: appTheme.headerBackgroundColor, id: `${PhotoCapture.PHOTO_CAPTURE}_daylightOnCar_text` },
                                        React.createElement(StyledCircleSpan, null, "2"))),
                                React.createElement(Grid, { item: true },
                                    React.createElement("span", null, translateFn(IntelligentPhotoCatureImageConstant.daylightOnCar.text)))),
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(StyledDivDefaultImage, { backgroundImage: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_WELLITAREA), id: `${PhotoCapture.PHOTO_CAPTURE}_daylightOnCar_image` }))),
                        React.createElement(Grid, { container: true, direction: "row", justify: "center", alignItems: "center" },
                            React.createElement(StyledGridScriptText, { container: true, item: true, xs: 6 },
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement(StyledDivCircle, { backgroundColor: appTheme.headerBackgroundColor, id: `${PhotoCapture.PHOTO_CAPTURE}_manViewingCar_image` },
                                        React.createElement(StyledCircleSpan, null, "3"))),
                                React.createElement(Grid, { item: true },
                                    React.createElement("span", null, translateFn(IntelligentPhotoCatureImageConstant.manViewingCar.text)))),
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(StyledDivDefaultImage, { backgroundImage: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_APPRAISER_VIEW), id: `${PhotoCapture.PHOTO_CAPTURE}_manViewingCar_image` }))))),
                React.createElement(Grid, null,
                    React.createElement(StyledLabelBottom, null, translateFn(ScriptQuestionConstant.LABEL_BOTTOM))))),
            questionSubType === PhotoCaptureAttributeType.ACKNOWLEDGEMENT && (React.createElement(PreLoadQuestionComponent, null,
                React.createElement(Grid, { container: true, direction: "row", alignItems: "center" },
                    React.createElement(Checkbox, { id: PhotoCaptureScriptQuestionIds.ID_TNC_CHECKBOX, checked: isTNCAccepted, label: translateFn(ScriptQuestionConstant.ACCEPT_TNC), onChange: onCheckboxClick, labelColor: appTheme.headerBackgroundColor })))),
            React.createElement(PhotoCaptureFraudWarningModal, { headerBackgroundColor: appTheme.headerBackgroundColor, footerBackgroundColor: appTheme.applicationBackgroundColor, headerColor: appTheme.headerTextColor, iUnderstandButtonBackgroundColor: appTheme.primaryButtonBackgroundColor, iUnderstandButtonTextColor: appTheme.primaryButtonTextColor, isModalOpen: isModalOpen, content: fraudStatement || '', onModalClose: onModalClose, onIUnderstandClick: onIUnderstandClick })),
        shouldLanguageDropdownDisplay && (React.createElement(LinkContainer, null,
            appTheme.termsOfUseUrl && (React.createElement(LinkButton, null,
                React.createElement("a", { target: "_blank", href: appTheme.termsOfUseUrl }, translateFn(PhotoCaptureConstants.TERMS_OF_USE)))),
            appTheme.privacyPolicyUrl && (React.createElement(LinkButton, null,
                React.createElement("a", { target: "_blank", href: appTheme.privacyPolicyUrl }, translateFn(PhotoCaptureConstants.PRIVACY_POLICY))))))));
};
//# sourceMappingURL=IntelligentScriptQuestionComponent.js.map